<template>
    <div>
        <div class="card mb-3" id="customer">
            <div class="card-header headline customer">
                <div class="row">
                    <!--<h2 class="text-white d-inline">سرفصلها</h2>-->
                    <div class="input-group col-lg-5">
                        <div class="input-group-prepend">
                            <span class="input-group-text">سرفصل</span>
                        </div>
                        <vs-select :data="mainAccounts" :mode="'create'"
                                   :header="{multiple: false, label: 'title'}"
                                   @onChange="onChange"></vs-select>
                    </div>
                    <!--<div class="input-group col-lg-5">-->
                    <!--<div class="input-group-prepend">-->
                    <!--<span class="input-group-text">زیر سرفصل :</span>-->
                    <!--</div>-->
                    <!--<vs-select :data="secondAccounts" :mode="'create'"-->
                    <!--:header="{multiple: false, label: 'outSourceName'}"-->
                    <!--@onChange="onChange2"></vs-select>-->
                    <!--</div>-->
                    <div class="input-group col-lg-3"></div>
                    <div class="input-group col-lg-2">
                        <button class="btn btn-secondary float-left" @click="onCreateMainClicked">افزودن سرفصل</button>
                    </div>
                    <div class="input-group col-lg-2">
                        <button class="btn btn-secondary float-left" @click="onModalButtonClicked">افزودن زیر سرفصل</button>
                    </div>
                </div>
            </div>


            <div class="card-body">
                <div class="row">
                    <div class="col-lg-12 mb-3">
                        <input type="text" class="form-control" placeholder="جستجو..." @input="onSearchInput"
                               v-model="searchString">
                    </div>
                    <div class="col-lg-12 mt-5" v-if="customers.length < 1">
                        <h3 class="text-center no-item-alert">سرفصل ثبت نشده است!</h3>
                    </div>
                    <div class="col-lg-3 mb-3" v-for="(item, index) in customers">
                        <div class="card shadow" @click="onCardClicked(index)">
                            <div class="row p-2">
                                <div class="col-lg-12">
                                    <h4 class="text-center">{{item.outSourceName}}</h4>
                                    <br>
                                    <span>مانده: </span>
                                    <span>{{item.remain<0 ? "(" + (item.remain*-1).toLocaleString() +"-)": item.remain.toLocaleString()}}</span>
                                    <br>
                                    <span>شماره تماس:</span>
                                    <span>{{item.phoneNumber}}</span>
                                    <br/>
                                    <span>کد ملی:</span>
                                    <span>{{item.branchCode}}</span>
                                    <br/>
                                    <span>توضیحات: </span>
                                    <span>{{item.description}}</span>
                                </div>
                            </div>

                        </div>
                    </div>
                    <!--<div v-if="customers.length > 7 && lastRespond.length > 7" class="col-lg-12 text-center mb-3" @click="getcustomers">
                        <button class="btn btn-success">نمایش حساب های بیشتر</button>
                    </div>-->
                    <div class="col-lg-12">
                        <div class="sk-circle" id="loading">
                            <div class="sk-circle1 sk-child"></div>
                            <div class="sk-circle2 sk-child"></div>
                            <div class="sk-circle3 sk-child"></div>
                            <div class="sk-circle4 sk-child"></div>
                            <div class="sk-circle5 sk-child"></div>
                            <div class="sk-circle6 sk-child"></div>
                            <div class="sk-circle7 sk-child"></div>
                            <div class="sk-circle8 sk-child"></div>
                            <div class="sk-circle9 sk-child"></div>
                            <div class="sk-circle10 sk-child"></div>
                            <div class="sk-circle11 sk-child"></div>
                            <div class="sk-circle12 sk-child"></div>
                        </div>
                    </div>
                    <div v-if="!autoload && customers.length < dataCount" class="col-lg-12 text-center my-3">
                        <button class="btn btn-success" @click="getCustomers">نمایش موارد بیشتر
                            ({{customers.length}}/{{dataCount}})
                        </button>
                        <div class="col-2 offset-5 my-2">
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">تعداد نمایش</span>
                                </div>
                                <input class="form-control" type="text" @change="changePageSize" v-model="queryParams.pageSize">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="customer-modal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header bg-warning-grad glow-warning">
                        <h5 v-if="params.mode === 'create'" class="modal-title text-white">افزودن حساب</h5>
                        <h5 v-if="params.mode === 'edit'" class="modal-title text-white">ویرایش حساب</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row" v-if="selectedMain === 1">
                            <div class="col-lg-6 offset-lg-3 mb-2">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">نام بانک</span>
                                    </div>
                                    <vs-select :data="bankList" :selected-val="preselectedBank" :mode="'create'"
                                               :header="{multiple: false, label: 'name'}"
                                               @onChange="onBankChange"></vs-select>
                                </div>
                            </div>
                            <div class="col-lg-6 mb-2">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">شعبه</span>
                                    </div>
                                    <input class="form-control" type="text" v-model="customer.branchName">
                                </div>
                            </div>
                            <div class="col-lg-6 mb-2">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">صاحب حساب</span>
                                    </div>
                                    <input class="form-control" type="text" v-model="customer.branchCode">
                                </div>
                            </div>
                            <div class="col-lg-6 mb-2">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">شماره کارت</span>
                                    </div>
                                    <input class="form-control" type="text" v-model="customer.kartNumber">
                                </div>
                            </div>
                            <div class="col-lg-6 mb-2">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">شماره شبا</span>
                                    </div>
                                    <input class="form-control" type="text" v-model="customer.shebaCode">
                                </div>
                            </div>
                            <div class="col-lg-6 mb-2">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">نوع حساب</span>
                                    </div>
                                    <vs-select :data="accountTypes" :selected-val="preselectedAccountType"
                                               :mode="'create'"
                                               :header="{multiple: false, label: 'name'}"
                                               @onChange="onAccountTypeChange"></vs-select>
                                </div>
                            </div>
                            <div class="col-lg-6 mb-2">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">شماره حساب</span>
                                    </div>
                                    <input class="form-control" type="number" v-model="customer.accountNumber">
                                </div>
                            </div>
                        </div>

                        <div class="row" v-else>
                            <div class="col-lg-6 mb-2">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">سرفصل حساب :</span>
                                    </div>
                                    <vs-select :data="mainAccounts" :mode="'create'"
                                               :header="{multiple: false, label: 'title'}"
                                               @onChange="selectMainAccount"></vs-select>
                                </div>
                            </div>
                            <div class="col-lg-6 mb-2">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">نام سرفصل</span>
                                    </div>
                                    <input class="form-control" type="text" v-model="customer.outSourceName">
                                </div>
                            </div>
                            <div class="col-lg-6 mb-2">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">شماره تماس</span>
                                    </div>
                                    <input class="form-control" type="number" v-model="customer.phoneNumber">
                                </div>
                            </div>
                            <div class="col-lg-6 mb-2">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">کد ملی</span>
                                    </div>
                                    <input class="form-control" type="number" v-model="customer.branchCode">
                                </div>
                            </div>
                            <div class="col-lg-6 mb-2">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">کد اقتصادی</span>
                                    </div>
                                    <input class="form-control" type="number" v-model="customer.shebaCode">
                                </div>
                            </div>
                            <div class="col-lg-6 mb-2">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">کد پستی</span>
                                    </div>
                                    <input class="form-control" type="number" v-model="customer.accountNumber">
                                </div>
                            </div>
                            <div class="col-lg-6 mb-2">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">آدرس</span>
                                    </div>
                                    <input class="form-control" type="text" v-model="customer.address">
                                </div>
                            </div>
                        </div>
                        <div class="input-group mt-2">
                            <div class="input-group-prepend">
                                <span class="input-group-text">توضیحات</span>
                            </div>
                            <input class="form-control" type="text" v-model="customer.description">
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary mr-2" data-dismiss="modal">بستن</button>
                        <button type="button" class="btn btn-danger mr-2" v-if="params.mode === 'edit'" @click="deleteItem()">حذف</button>
                        <button v-if="params.mode === 'edit'" type="button" class="btn btn-success mr-2" data-dismiss="modal" @click="onTransactionModalClicked">گردش حساب</button>
                        <button type="button" class="btn btn-primary m-0" @click="onModalOk">ذخیره</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="transactionModal" tabindex="-1" role="dialog" aria-labelledby="transactionTitle" aria-hidden="true" style="overflow-y: scroll">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header bg-danger-grad glow-danger">
                        <h5 class="modal-title text-white" id="transactionTitle">گردش حساب</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row" v-if="listView">
                            <div class="col-lg-12" v-for="(item, index) in transactions">
                                <div class="card list" @click="onCardClicked($event, index)">
                                    <div class="row">
                                        <!--<div class="col-md-3">-->
                                        <!--<strong>{{item.factor}}</strong>-->
                                        <!--</div>-->
                                        <!--<div class="col-md-3">-->
                                        <!--<strong>حساب: </strong>-->
                                        <!--<span>{{item.account}}</span>-->
                                        <!--</div>-->
                                        <div class="col-md-3">
                                            <strong>مبلغ: </strong>
                                            <span v-if="item.creditor === 0 && item.debtor !== 0" class="text-success">{{item.debtor}} +</span>
                                            <span v-if="item.debtor === 0 && item.creditor !== 0" class="text-danger">{{item.creditor}} -</span>
                                        </div>
                                        <div class="col-md-3">
                                            <strong>تاریخ: </strong>
                                            <span>{{item.persianDate}}</span>
                                        </div>
                                        <div class="col-md-6">
                                            <strong>توضیحات: </strong>
                                            <span>{{item.description}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row" v-else>
                            <div class="col-lg-6 product-container" v-for="(item, index) in transactions">
                                <div class="card transaction mt-2 mb-2" @click="onCardClicked($event, index)">
                                    <div class="card-header">
                                        <h4 class="text-center">{{item.factor}}</h4>
                                    </div>
                                    <div class="card-body">
                                        <span><b>حساب: </b></span>
                                        <span>{{item.account}}</span>
                                        <br>
                                        <span><b>توضیحات: </b></span>
                                        <span>{{item.description}}</span>
                                        <br>
                                        <span><b>تاریخ: </b></span>
                                        <span>{{item.persianDate}}</span>
                                        <br>
                                        <div class="text-center">
                                            <h5 class="d-inline">مبلغ: </h5>
                                            <h5 v-if="item.creditor === 0 && item.debtor !== 0" class="text-success d-inline">{{item.debtor}}</h5>
                                            <h5 v-if="item.debtor === 0 && item.creditor !== 0" class="text-danger d-inline">{{item.creditor}}</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col-lg-12 text-center">
                                <div v-if="transactions === undefined || transactions.length < 1" class="col-lg-12">
                                    <h3 class="no-item-alert text-center">رکوردی یافت نشد!</h3>
                                </div>
                                <div v-if="transactions !== undefined && transactions.length < transactionCount" class="col-lg-12 text-center" @click="getTransactions">
                                    <button class="btn btn-success">نمایش موارد بیشتر</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary mr-1" data-dismiss="modal">بستن</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="mainAccount-modal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header bg-warning-grad glow-warning">
                        <h5 class="modal-title text-white">ثبت سرفصل حساب</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-lg-6 my-2">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">نام سرفصل</span>
                                    </div>
                                    <input class="form-control" type="text" v-model="mainModel.title">
                                </div>
                            </div>

                            <!--<div class="col-lg-6 my-2">-->
                            <!--<div class="input-group">-->
                            <!--<div class="input-group-prepend">-->
                            <!--<span class="input-group-text">سال مالی :</span>-->
                            <!--</div>-->
                            <!--<vs-select :data="saleMalis" :mode="'create'"-->
                            <!--:header="{multiple: false, label: 'name'}"-->
                            <!--@onChange="selectSalemali"></vs-select>-->
                            <!--</div>-->
                            <!--</div>-->
                            <div class="col-lg-6 my-2">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">نوع مانده حساب :</span>
                                    </div>
                                    <vs-select :data="accountNatures" :mode="'create'"
                                               :header="{multiple: false, label: 'name'}"
                                               @onChange="selectaccountNatureMain"></vs-select>
                                </div>
                            </div>
                            <!--<div class="col-lg-12   my-2">-->
                            <!--<div class="input-group">-->
                            <!--<div class="input-group-prepend">-->
                            <!--<span class="input-group-text">توضیحات</span>-->
                            <!--</div>-->
                            <!--<input class="form-control" type="text" v-model="accountOutSourceModel.description">-->
                            <!--</div>-->
                            <!--</div>-->

                        </div>
                    </div>
                    <div class="modal-footer d-block">
                        <button type="button" class="btn btn-secondary mr-2" data-dismiss="modal">بستن</button>
                        <!--<button type="button" class="btn btn-danger mr-2" @click="deleteMainItem()">حذف</button>-->
                        <button type="button" class="btn btn-primary" @click="onMainlOk">ذخیره</button>
                    </div>
                </div>
            </div>
        </div>


    </div>
</template>


<script>
    import * as $ from 'jquery';
    import axios from 'axios';
    import Vue from 'vue';
    import BaseService from "../../_framework/api/BaseService";
    import Utils from "../../_framework/utils/Utils";
    import VsSelect from "../../_framework/VsSelect";
    import EventBus from "../../_framework/event-bus.js";
    import Moment from "moment-jalali";

    //$(".product-container:nth-child(1)").css("background-color","green");
    $(".voucher-modal-button").click(() => {
        $("#voucherData").modal("show");
    });

    export default {
        name: 'customer',
        components: {VsSelect},
        data() {
            return {
                customers: [],
                queryParams: {
                    pageSize: 12000,
                    pageIndex: 0,

                    types: 100
                    // types: [1,2,3,4,5,6,7,8,12,13,16,17,18,20]
                },
                mainModel: {
                    id: 0,
                    code: "",
                    title: "",
                    parrentId: null,
                    accountNature: 1,
                    accontType: 4,
                },

                customer: {
                    phoneNumber: "",
                    address: "",
                    outSourceName: "",
                    type: 3
                },

                params: {
                    mode: 'create'
                },
                searchString: "",
                preselectedBank: {},
                bankList: [
                    {name: "کشاورزی"},
                    {name: "انصار"},
                    {name: "آینده"},
                    {name: "بانک مرکزی"},
                    {name: "بانک شهر"},
                    {name: "دی"},
                    {name: "اقتصاد نوین"},
                    {name: "گردشگری"},
                    {name: "قوامین"},
                    {name: "کارافرین"},
                    {name: "مسکن"},
                    {name: "مهر"},
                    {name: "ملت"},
                    {name: "ملی"},
                    {name: "پارسیان"},
                    {name: "پاسارگاد"},
                    {name: "پست بانک"},
                    {name: "رفاه"},
                    {name: "رسالت"},
                    {name: "صادرات"},
                    {name: "صنعت و معدن"},
                    {name: "سامان"},
                    {name: "سپه"},
                    {name: "سینا"},
                    {name: "تجارت"},
                    {name: "سرمایه"},
                ],
                preselectedAccountType: {},
                accountTypes: [
                    {
                        id: 1,
                        name: "جاری"
                    },
                    {
                        id: 2,
                        name: "قرض الحسنه"
                    },
                    {
                        id: 3,
                        name: "سپرده"
                    },
                    {
                        id: 4,
                        name: "تسهیلات"
                    }
                ],
                transactions: [],
                listView: true,
                transactionsQuery: {
                    pageSize: 8,
                    pageIndex: 0,
                    code: 0
                },
                dataCount: 0,
                transactionCount: 0,

                autoload: false,
                isSending: false,
                mainAccounts: [],
                // mainAccounts: [
                //     {id: 0, title: "همه حسابها"},
                //     {id: 1, title: "بانکها"},
                //     {id: 2, title: "صندوق ها"},
                //     {id: 3, title: "مشتری ها"},
                //     {id: 4, title: "اشخاص"},
                //     {id: 5, title: "تامین کننده ها"},
                //     {id: 6, title: "سرمایه(موجودی اولیه)"},
                //     {id: 7, title: "درآمدها"},
                //     {id: 8, title: "هزینه ها"},
                //     // {id: 9, title: "تولید"},
                //     {id: 10, title: "فروش"},
                //     {id: 11, title: "خرید"},
                //     {id: 12, title: "چک های دریافتی"},
                //     {id: 13, title: "چک های پرداختی"},
                //
                //     {id: 15, title: "موجودی اولیه کالا"},
                //     {id: 16, title: "شرکاء"},
                //     {id: 17, title: "دارائی ها"},
                //     {id: 18, title: "بدهی ها"},
                //     {id: 20, title: "سایر سرفصلها"},
                //
                //
                //     // {id: 14, title: "فروش اینترنتی"},
                // ],
                selectedMain: 0,
                selectedCash: 0,
                keepData: false,
                showCash: false,
                isDetail: false,
                mainSel: "",
                secSell: "",
                secondAccounts: [],
                queryParams2: {
                    pageSize: 10000,
                    pageIndex: 0,
                    parrentId: 1
                },
                accountNatures: [
                    {
                        accountNature: 1,
                        name: "بدهکار"
                    },
                    {
                        accountNature: 2,
                        name: "بستانکار"
                    },
                    {
                        accountNature: 3,
                        name: "هردو"
                    },

                ],

            }
        },
        mounted() {
            this.autoload = JSON.parse(localStorage.getItem("autoload"));
            this.listView = JSON.parse(localStorage.getItem("listView"));
            // this.addtypes();
            EventBus.$on('listView', value => {
                this.listView = value;
            });
            this.getAllMains();

            this.getOutsource();
            if (JSON.parse(localStorage.getItem("autoload"))) {
                $(window).on("scroll", () => {
                    if (Utils.onBottomReached() && this.customers.length < this.dataCount) {
                        $("#loading").show();
                        this.getCustomers();
                    }
                });
            }
        },
        methods: {
            getAllMains() {
                new BaseService('AccountTitle', '/GetAllHead').getList().then(response => {
                    let a = response.data;
                    this.mainAccounts = [];
                    let bb = {id: 0, title: "همه حسابها", code: 0};
                    this.mainAccounts.push(bb);
                    for (let i of a) {
                        switch (i.id) {
                            case 1:
                                i.title = "بانکها";
                                break;
                            case 2:
                                i.title = "صندوق ها";
                                break;
                            case 3:
                                i.title = "مشتری ها";
                                break;
                            case 4:
                                i.title = "اشخاص";
                                break;
                            case 5:
                                i.title = "تامین کننده ها";
                                break;
                            case 6:
                                i.title = "سرمایه(موجودی اولیه)";
                                break;
                            case 7:
                                i.title = "درآمدها";
                                break;
                            case 8:
                                i.title = "هزینه ها";
                                break;
                            case 10:
                                i.title = "فروش";
                                break;
                            case 11:
                                i.title = "خرید";
                                break;
                            case 12:
                                i.title = "چک های دریافتی";
                                break;
                            case 13:
                                i.title = "چک های پرداختی";
                                break;
                            case 14:
                                i.title = "";
                                break;
                            case 15:
                                i.title = "موجودی اولیه کالا";
                                break;
                            case 16:
                                i.title = "شرکاء";
                                break;
                            case 17:
                                i.title = "دارائی ها";
                                break;
                            case 18:
                                i.title = "بدهی ها";
                                break;
                            case 20:
                                i.title = "سرفصلهای حسابداری";
                                break;

                        }
                        this.mainAccounts.push(i);
                    }
                }).catch(error => {
                    // error
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });
            },
            addtypes() {
                this.queryParams.types.push(1);
                // this.queryParams.types.push(2);
                // this.queryParams.types.push(3);
                // this.queryParams.types.push(4);
                // this.queryParams.types.push(5);
                // this.queryParams.types.push(6);
                // this.queryParams.types.push(7);
                // this.queryParams.types.push(8);
                // this.queryParams.types.push(12);
                // this.queryParams.types.push(13);
                // this.queryParams.types.push(16);
                // this.queryParams.types.push(17);
                // this.queryParams.types.push(18);
                // this.queryParams.types.push(20);
            },
            getOutsource() {
                new BaseService('outsource', '/getlist').getList(this.queryParams).then(response => {
                    this.customers = response.data.data;
                    this.dataCount = response.data.count;
                    $("#loading").hide();
                }).catch(error => {
                    // error
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });
            },
            changePageSize(e) {
                this.getCustomers(-1);
            },
            getCustomers(page) {
                if (page === -1) {
                    this.queryParams.pageIndex = 0;
                    this.customers = [];
                } else {
                    this.queryParams.pageIndex++;
                }
                $("#loading").show();
                new BaseService('outsource', '/getlist').getList(this.queryParams).then(response => {
                    this.customers.push.apply(this.customers, response.data.data);
                    this.dataCount = response.data.count;
                    $("#loading").hide();
                }).catch(error => {
                    // error
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });
            },
            onSearchInput() {
                this.queryParams.name = this.searchString;
                this.queryParams.pageIndex = 0;
                $("#loading").show();
                new BaseService('outsource', '/getlist').getList(this.queryParams).then(response => {
                    this.customers = response.data.data;
                    $("#loading").hide();
                }).catch(error => {
                    // error
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });
            },
            onCardClicked(index) {
                this.params.mode = 'edit';
                this.customer = JSON.parse(JSON.stringify(this.customers[index]));
                $("#customer-modal").modal("show");
            },
            onCreateMainClicked() {
                $("#mainAccount-modal").modal("show");
            },
            onModalButtonClicked() {

                this.params.mode = 'create';
                this.customer = {
                    phoneNumber: "",
                    address: "",
                    outSourceName: "",
                    branchCode: "",
                    shebaCode: "",
                    accountNumber: "",
                    type: this.selectedMain
                };
                this.customer.type = this.selectedMain;
                $("#customer-modal").modal("show");

            },
            onModalOk() {
                if (this.params.mode === 'create') {
                    this.onCreate(this.customer);
                } else {
                    this.onUpdate(this.customer);
                }
            },
            onCreate(customer) {
                if (this.selectedMain === 1) {
                    if (this.customer.accountOwner === null || this.customer.accountOwner === '' || this.customer.accountOwner === undefined) {
                        Utils.handleErrorWithNotification("لطفا بانک را وارد کنید", this.$noty);
                    } else if (this.customer.branchName === null || this.customer.branchName === '' || this.customer.branchName === undefined) {
                        Utils.handleErrorWithNotification("لطفا نام شعبه را وارد کنید", this.$noty);
                    } else if (this.customer.accountType === null || this.customer.accountType === '' || this.customer.accountType === undefined) {
                        Utils.handleErrorWithNotification("لطفا نوع حساب را وارد کنید", this.$noty);
                    } else if (this.customer.accountNumber === null || this.customer.accountNumber === '' || this.customer.accountNumber === undefined) {
                        Utils.handleErrorWithNotification("لطفا شماره حساب را وارد کنید", this.$noty);
                    } else {
                        if (!this.isSending) {
                            this.isSending = true;
                            customer.rowVersion = this.generateUuid();
                            new BaseService('outsource').create(customer).then(response => {
                                this.$noty.success("اطلاعات سرفصل با موفقیت افزوده شد.");
                                $("#customer-modal").modal("hide");
                                this.queryParams.pageIndex = 0;
                                new BaseService('outsource', '/getlist').getList(this.queryParams).then(response => {
                                    this.customers = response.data.data;
                                    $("#loading").hide();
                                    Utils.resetObject(this.customer);
                                    this.customer.type = 3;
                                }).catch(error => {
                                    // error
                                    Utils.handleErrorWithNotification(error.message, this.$noty);
                                });
                                this.isSending = false;
                            }).catch(error => {
                                this.isSending = false;
                                Utils.handleErrorWithNotification(error.message, this.$noty);
                            });
                        }
                    }
                } else {
                    if (!this.isSending) {
                        this.isSending = true;
                        customer.rowVersion = this.generateUuid();
                        new BaseService('outsource').create(customer).then(response => {
                            this.$noty.success("اطلاعات سرفصل با موفقیت افزوده شد.");
                            $("#customer-modal").modal("hide");
                            this.queryParams.pageIndex = 0;
                            new BaseService('outsource', '/getlist').getList(this.queryParams).then(response => {
                                this.customers = response.data.data;
                                $("#loading").hide();
                                Utils.resetObject(this.customer);
                                this.customer.type = 3;
                            }).catch(error => {
                                // error
                                Utils.handleErrorWithNotification(error.message, this.$noty);
                            });
                            this.isSending = false;
                        }).catch(error => {
                            this.isSending = false;
                            Utils.handleErrorWithNotification(error.message, this.$noty);
                        });
                    }
                }
            },
            onUpdate(customer) {
                if (!this.isSending) {
                    this.isSending = true;

                    customer.categoryId = 0;
                    new BaseService('outsource').update(customer).then(response => {
                        this.$noty.success("اطلاعات سرفصل با موفقیت ویرایش شد.");
                        $("#customer-modal").modal("hide");
                        this.queryParams.pageIndex = 0;
                        new BaseService('outsource', '/getlist').getList(this.queryParams).then(response => {
                            this.customers = response.data.data;
                            $("#loading").hide();
                            Utils.resetObject(this.customer);
                            this.customer.type = 3;
                        }).catch(error => {
                            // error
                            Utils.handleErrorWithNotification(error.message, this.$noty);
                        });
                        this.isSending = false;
                    }).catch(error => {
                        this.isSending = false;
                        Utils.handleErrorWithNotification(error.message, this.$noty);
                    });
                }
            },
            onTransactionModalClicked() {
                $("#transactionModal").modal('show');
                this.transactionsQuery.code = this.customer.code;
                new BaseService('reports', '/gettransactionreport').getList(this.transactionsQuery).then(response => {
                    this.transactions = response.data.data;
                    this.transactionCount = response.data.count;
                    if (this.transactions !== undefined) {
                        for (let item of this.transactions) {
                            item.persianDate = Moment(item.date, 'YYYY-MM-DD').format('jDD jMMMM jYYYY');
                        }
                    }
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });
            },
            getTransactions() {
                this.transactionsQuery.pageIndex++;
                new BaseService('reports', '/gettransactionreport').getList(this.transactionsQuery).then(response => {
                    this.transactions.push.apply(this.transactions, response.data.data);
                    for (let item of this.transactions) {
                        item.persianDate = Moment(item.date, 'YYYY-MM-DD').format('jDD jMMMM jYYYY');
                    }
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.response.data.message, this.$noty);
                });
            },
            deleteItem() {
                if (confirm("آیا از حذف اطمینان دارید؟")) {
                    if (!this.isSending) {
                        this.isSending = true;
                        new BaseService('outsource').delete(this.customer.id).then(response => {
                            this.$noty.success("با موفقیت حذف شد.");
                            $("#customer-modal").modal("hide");
                            this.queryParams.pageIndex = 0;
                            new BaseService('outsource', '/getlist').getList(this.queryParams).then(response => {
                                this.customers = response.data.data;
                                $("#loading").hide();
                                Utils.resetObject(this.customer);
                                this.customer.type = 3;
                            }).catch(error => {
                                // error
                                Utils.handleErrorWithNotification(error.message, this.$noty);
                            });
                            this.isSending = false;
                        }).catch(error => {
                            this.isSending = false;
                            this.$noty.error(error.data.message);
                            Utils.handleErrorWithNotification(error.data.message, this.$noty);
                        });
                    }
                }
            },
            onChange: function (val) {
                //console.log(val)
                if (val) {
                    this.mainSel = val.title;
                    if (val.id === 0) {
                        this.selectedMain = val.code;
                        this.keepData = false;
                        this.queryParams.outsourceType = this.selectedMain;
                        this.queryParams.pageIndex = 0;
                        this.queryParams.types = 100;
                        this.getOutsource();
                        // this.addtypes();
                        // this.queryParams2.types = this.selectedMain;
                    } else {
                        this.selectedMain = val.code;
                        this.queryParams.outsourceType = this.selectedMain;
                        this.queryParams.pageIndex = 0;
                        this.queryParams2.types = this.selectedMain;
                        this.queryParams.types = this.selectedMain;
                        this.getOutsource();
                        // this.getProviders();

                    }
                }

            },
            onChange2(val) {
                if (val) {
                    this.secSell = val.outSourceName;
                }
                this.isDetail = true;
                this.queryParams.outsourceId = val.id;
                this.keepData = false;
                this.selectedCash = val.id;

                new BaseService('reports', '/GetBookReport').getList(this.queryParams).then(response => {
                    let actions = response.data.data;
                    this.dataCount = response.data.count;
                    this.totalDebtor = 0;
                    this.totalCreditor = 0;
                    this.totalRemain = 0;
                    this.transactions = [];
                    if (actions !== undefined || actions != null) {
                        let remains = 0;
                        for (let item of actions) {
                            let date = Moment(item.date, 'YYYY-MM-DD').format("jDD jMMMM jYYYY");
                            Vue.set(item, "persianDate", date);
                            item.remains = item.debtor - item.creditor + item.remain + remains;
                            remains = item.remains;
                            this.totalDebtor = this.totalDebtor + item.debtor;
                            this.totalCreditor = this.totalCreditor + item.creditor;
                            this.totalRemain = remains;
                            this.transactions.push(item);
                        }
                    }
                    $("#loading").hide();
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });
            },
            getProviders() {
                new BaseService('outsource', '/getlist').getList(this.queryParams2).then(response => {
                    this.secondAccounts = response.data.data;
                    // console.log(this.banks);
                    let allPro = {
                        id: 0,
                        outSourceName: "همه موارد"
                    };
                    // this.banks.push(allPro);
                }).catch(error => {
                    console.log(error)
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });
            },
            onBankChange(e) {
                this.customer.accountOwner = e.name;
                this.customer.outSourceName = e.name;
            },
            onAccountTypeChange(e) {
                this.customer.accountType = e.id;
            },
            selectaccountNatureMain(val) {
                if (val && val.accountNature) {

                    this.mainModel.accountNature = val.accountNature;
                }
            },
            onMainlOk() {
                if (this.mainModel.name === null || this.mainModel.name === "") {
                    Utils.handleErrorWithNotification("لطفا نام سرفصل حساب را کنید", this.$noty);
                } else {
                    if (!this.isSending) {
                        this.isSending = true;
                        new BaseService('AccountTitle/CreateMain').create(this.mainModel).then(response => {
                            this.$noty.success("اطلاعات با موفقیت ثبت شد.");
                            this.isSending = false;
                            this.getAllMains();
                            $("#mainAccount-modal").modal("hide");
                        }).catch(error => {
                            this.isSending = false;
                            Utils.handleErrorWithNotification(error.data.message, this.$noty);
                        });
                    }

                }
            },
            selectMainAccount(val) {
                if (val) {
                    this.customer.type = val.code;
                }
            },


        },
        beforeRouteLeave(to, from, next) {
            $(window).unbind('scroll');
            if ($("#customer-modal").hasClass("show")) {
                $("#customer-modal").modal("hide");
                next(false);
            } else {
                if ($("#transactionModal").hasClass("show")) {
                    $("#transactionModal").modal("hide");
                    next(false);
                } else {
                    next();
                }

            }

        },
    }
</script>